import { InvoiceStatus } from '@features/invoicesLegacy/enums/invoiceStatus'

import { InvoicesSummaryData } from '../types/invoicesSummaryData'

export const getBadgeAmountForStatusAll = (data: InvoicesSummaryData) => data[InvoiceStatus.All].count
